module.exports = __webpack_public_path__ + "img/code_android.66698235.png";